module.exports = __webpack_public_path__ + "img/aside_logo3.17187e17.png";